module.exports = require('./helpers/bundle-url').getBundleURL('kQlYE') + "logo.7718c6df.svg";